import {ioJsonAction, ioJsonManualAction} from 'Core/store/actions/io';
import {isSuccessful} from 'Core/helpers/io';
import {actionCreators} from './reducer';
import * as dataMap from './dataMap';
import {getArray} from 'Core/helpers/data';

/**
 * Load the list of requests for adding/removing customers from a specific group that are in progress into Redux store
 * @note Adding/removing customers using a file or customer segments is done asynchronously on backend.
 *
 * @param {function} [abortCallback=(abortController)=>{}] - Callback function that will receive AbortController as an
 * argument.
 * @param {string} customerGroupId - DB ID of the customer group.
 * @param {boolean} [ignoreErrors=false] - Flag that specifies if response errors are ignored.
 * @param {?string} [clientId=null] - Client ID.
 * @return {function(*): Promise<CustomerGroupChangeRequestDataObject[]|undefined>}
 */
export const loadCustomerGroupChangeInProgressRequestsAction = (
	abortCallback, customerGroupId, ignoreErrors = false, clientId = null
) => dispatch => {
	const action = (ignoreErrors ? ioJsonManualAction : ioJsonAction);
	return action(
		abortCallback,
		'defaultAuthorizedApi',
		'customer-group/fetch-import-requests',
		{clientId, id: customerGroupId}
	)(dispatch)
		.then(res => {
			if (isSuccessful(res)) {
				const result = getArray(res, 'data').map(i => dataMap.input(i));
				dispatch(actionCreators.setInProgressChangeRequests(result));
				return result;
			} else {
				dispatch(actionCreators.setInProgressChangeRequests(undefined));
				return undefined;
			}
		})
		.catch(() => {
			dispatch(actionCreators.setInProgressChangeRequests(undefined));
			return undefined;
		});
};

/**
 * Clear the status of customers being added or removed from the specific customer group from the Redux store
 * @return {(function(*): void)|*}
 */
export const clearCustomerGroupProgressAction = () => dispatch => {
	dispatch(actionCreators.setInProgressChangeRequests(null));
}